// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3N_lW","range":"MonthRangeSwitch_range__1kqCZ","disabled":"MonthRangeSwitch_disabled__1Uk7m"};